export default __webpack_public_path__ + "static/media/delete-notification-icon.8caec870.svg";